import apiServices, { connectorClient } from '../utils/axios';

export const fetchApsExtractionList = async ({ offset, length, type }) => {
  const res = await apiServices.get(`/aps/extracts?length=${length}&offset=${offset}&module_type=${type}`);
  return res.data;
};

export const fetchApsExtractionDetail = async ({ table, offset, length }) => {
  const res = await apiServices.get(`/aps/extracts/detail?table=${table}&length=${length}&offset=${offset}`);
  return res.data;
};

export const updateExtraction = async ({id, data}) => {
  const res = await apiServices.put(`/extracts/${id}/data`, {data});
  return res.data;
};

export const deleteExtraction = async (id) => {
  const { data } = await apiServices.delete(`/aps/extracts?id=${id}`);
  return data;
};

export const fetchApsDownloadSV = async (id) => {
  const res = await apiServices.get(`extracts/${id}/csv`, {responseType: "blob"});
  return res.data;
};


export const fetchETSUpload = async (access_token) => {
  const res = await apiServices.post(`/aps/project/excel/ets`, { access_token });
  return res.data;
};

export const activeSgbuildexElement = async ({connectionId, element}) => {
  const { data } = await connectorClient(connectionId).post(`/sgbuildex/activate/${element}`);
  return data;
};

export const deactiveSgbuildexElement = async ({connectionId, element}) => {
  const { data } = await connectorClient(connectionId).post(`/sgbuildex/deactivate/${element}`);
  return data;
};

export const fetchTokenRefreshPBI = async () => {
  const res = await apiServices.get(`/powerbi/refresh-quota`);
  return res.data;
};

export const updateParameterPBI= async ({module, table_name}) => {
  const res = await apiServices.post(`/powerbi/parameter/${module}/${table_name}`);
  return res.data;
};

export const refreshPBI= async () => {
  const res = await apiServices.post(`/powerbi/refresh`);
  return res.data;
};